import { z } from "zod";
import { CommunityAuthor } from "./author.js";
import { CommunityReactableItemType, CommunityReactionType } from "./enums.js";
export const CommunityReactionSummary = z.object({
    type: CommunityReactionType,
    count: z.number().int().nonnegative(),
    reactedByMe: z.boolean(),
    previewAuthors: z.array(CommunityAuthor).default([]),
});
export const CommunityItemParams = z.object({
    id: z.string().uuid(),
});
export const ReactToCommunityItemRequest = z.object({
    itemType: CommunityReactableItemType,
    itemId: z.string().uuid(),
    reactionType: CommunityReactionType,
    active: z.boolean().default(true),
});
export const ReactToCommunityItemResponse = z.object({
    reactions: z.array(CommunityReactionSummary),
});
export const ListCommunityItemReactionsQuery = z.object({
    itemType: CommunityReactableItemType,
    itemId: z.string().uuid(),
});
export const CommunityReactionRecord = z.object({
    reactionType: CommunityReactionType,
    author: CommunityAuthor,
});
export const ListCommunityItemReactionsResponse = z.object({
    reactors: z.array(CommunityReactionRecord),
});
//# sourceMappingURL=reaction.js.map